import Component from '../abstracts/Component';

export default class NewArrivalsComponent extends Component {
  get SELECTORS() {
    return {
      main: '[data-arrivals-id]',
    };
  }
  constructor() {
    super();
    this.showArrivalsClass = 'show-arrivals';
    this.activeLinkClass = 'active-link';
  }
  hideArrivals(idComponent) {
    let containers = `[id^="new-${idComponent}"]`
    let allArrivals = document.querySelectorAll(containers);
    for (let arrival of allArrivals) {
      arrival.classList.remove(this.showArrivalsClass);
    }
  }
  showArrivals(id) {
    let arrivalsContainer = document.getElementById(id);
    arrivalsContainer.classList.add(this.showArrivalsClass);
    //check with slick css class if instantiated
    let thereIsSlick = arrivalsContainer.classList.contains('slick-initialized');

    if (!thereIsSlick) {
      //Inject slick module
      this.$emit(this.$customEvents.CAROUSEL.triggerCarousel, arrivalsContainer.classList);
    }
  }
  setInactiveLinks(links) {
    for (let link of links) {
      link.classList.remove(this.activeLinkClass);
    }
  }
  initArrivalsHandler() {
    let triggers = document.querySelectorAll(this.SELECTORS.main);
    for (let [index, trigger] of triggers.entries()) {
      trigger.addEventListener('click', () => {
        let idArrival = trigger.dataset.arrivalsId;
        let idComponent = trigger.dataset.componentId;
        this.setInactiveLinks(triggers);
        trigger.classList.add(this.activeLinkClass);
        this.hideArrivals(idComponent);
        this.showArrivals(idArrival);
      });
    }
  }

  render() {
    this.log('Rendering..');
    this.initArrivalsHandler();
  }
}
